import { render, staticRenderFns } from "./mobile-links.vue?vue&type=template&id=078f8e94"
import script from "./mobile-links.vue?vue&type=script&lang=ts"
export * from "./mobile-links.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports